import { render, staticRenderFns } from "./file-type-seting.vue?vue&type=template&id=2e6b72d8&scoped=true"
import script from "./file-type-seting.vue?vue&type=script&lang=js"
export * from "./file-type-seting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b72d8",
  null
  
)

export default component.exports